import React from "react"

import "./hostquad.css"

import extendImg from './extend-image.png'
import maximImg from './maximize-image.png'
import ampImg from './amplify-image.png'
import demoImg from './demo-image.png'

const hostQuad = ( ) => {


    return (
        <section className="hostquad" id="HostQuad">
            <div className="containfix">
                <h1>WHEN YOU HOST AN AI WEEK EVENT YOU WILL:</h1>
                <div className="grid5050">

                    <div className="rg12021">

                        <h2 className="subQuad">EXTEND</h2>
                        <hr className="greenlineshort" />
                        <p className="quadPara">Extend your reach to thousands of AI and tech leaders, decision makers and influencers from government, tech, academia, and influential VCs.</p>
                        <img alt="" src={extendImg} className="halfImage adjustImg" />
                    </div>
                    <div className="rg22021">
                        <h2 className="subQuad">MAXIMIZE</h2>
                        <hr className="greenlineshort" />
                        <p className="quadPara maximize">Maximize your event's exposure by being included on our official AI Week Calendar.</p>
                        <img alt="" src={maximImg} className="halfImage adjustMax" />
                    </div>
                    <div className="rg12021">

                        <h2 className="subQuad">AMPLIFY</h2>
                        <hr className="greenlineshort" />
                        <p className="quadPara">Amplify your brand and event through inclusion in AI Week marketing emails and social media promotion.</p>
                        <img alt="" src={ampImg} className="halfImage" />
                    </div>
                    <div className="rg22021">
                        <h2 className="subQuad">DEMONSTRATE</h2>
                        <hr className="greenlineshort" />
                        <p className="quadPara">Demonstrate your organization's market leadership, expertise, and solutions.</p>
                        <img alt="" src={demoImg} className="halfImage adjustDemo" />
                    </div>
                </div>
                <div>
                    <p className="quadPara">Simply put, the sky is the limit! Whether it be an event you want to build from scratch or want to repurpose, being part of AI Week will help you to further engage an audience of decision makers and influencers.

<br /><br />Our award-winning events team is here to help! If you are building an event from scratch, our dedicated AI Week team will work with you to identify the best strategies and share best practices for putting together an incredible event.

                    </p>
                </div>
            </div>

        </section>

    )
}
export default hostQuad
